export default "/images/framework/Badge_04.81280866.svg?81280866";